export default __webpack_public_path__ + "static/media/avatar_talent_review.e350f1b7.svg";